<template>
    <BasicTile class="w-100 base-tile__background-secondary">
        <div class="my-referral-dashboard">


            <MyReferralStat class="item-1">
                <template v-slot:value>{{ userStore.user.referrals_count }}</template>
                <template v-slot:caption>Referred Users</template>
            </MyReferralStat>


            <div class="column-separator-left h-100"></div>


            <MyReferralStat class="item-2">
                <template v-slot:value>
                    <span class="d-flex align-start ga-2">
                        <coin-big style="width: 30px; height: 30px; position: relative; top: 5px;"></coin-big>
                        <span>{{ userStore.user.referrer_coins_total }}</span>
                    </span>
                </template>
                <template v-slot:caption>Referral Earnings</template>
            </MyReferralStat>


            <div class="column-separator-left h-100" v-if="isDesktopDevice"></div>


            <ReferralCode v-if="referralCode" :referralCode="referralCode" class="item-3" />
            <ShareViaSocialMedia v-if="referralCode" :referralCode="referralCode" class="item-4" />


        </div>
    </BasicTile>
</template>



<script setup>

import { computed } from 'vue';
import { useUserStore } from '@/store/UserStore';
import CoinBig from '@/icons/CoinBig.vue';
import BasicTile from '@/components/Tiles/Basic-Tile.vue';
import ReferralCode from './ReferralCode.vue';
import ShareViaSocialMedia from './ShareViaSocialMedia.vue';
import MyReferralStat from './MyReferral-Stat.vue';
import { isDesktop } from '@/utils/utils';

const userStore = useUserStore();
const isDesktopDevice = isDesktop();
const referralCode = computed(() => userStore.user.referral_code);

</script>